import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listDemandForecasts } from '@ebalance/proto/bffuser/v1/demand_service-DemandService_connectquery'
import {
  ListDemandForecastsRequestSchema,
  type ListDemandForecastsResponse,
} from '@ebalance/proto/bffuser/v1/demand_service_pb'
import { type UseQueryResult, keepPreviousData } from '@tanstack/react-query'

import type { DemandForecastListFilter } from '~/pages/DemandForecastList/models/tabDefinitions'

type UseListDemandForecastsOptions = {
  /**
   * false の間はクエリを発火しない。週間/月間/年間タブ (開発中プレースホルダ、
   * design 2026-07-15 ユーザー指示) では一覧取得 API を呼ばないため、
   * DemandForecastListPage が単日タブ選択時のみ true を渡す。
   * 省略時は true (= 既存呼び出しは常時発火のまま、後方互換)。
   */
  enabled?: boolean
}

export function useListDemandForecasts(
  filter: DemandForecastListFilter,
  options?: UseListDemandForecastsOptions,
): UseQueryResult<ListDemandForecastsResponse, ConnectError> {
  return useQuery(
    listDemandForecasts,
    create(ListDemandForecastsRequestSchema, {
      sections: filter.sections,
      targetDateFrom: filter.targetDate,
      targetDateTo: filter.targetDate,
      areaCodes: filter.areaCodes,
      status: filter.status,
    }),
    {
      enabled: options?.enabled ?? true,
      // 絞り込み (対象日・エリア・ステータス) を変えた直後は、 次の結果が届くまで前の
      // 結果を残す (`isPlaceholderData`)。 画面はそれを影の下に置き、 表を空にしない
      // (UI 辞書 region-loading.md「条件を変えた時に領域を空にしない」)。
      placeholderData: keepPreviousData,
    },
  )
}
